import { createFileRoute } from '@tanstack/react-router';
import { OrderDetails } from '@/features/orders/OrderDetails';

export const Route = createFileRoute('/r/$restaurantId/orders/$orderUuid')({
  component: OrderDetailsPage,
});

function OrderDetailsPage() {
  const { orderUuid } = Route.useParams();
  return (
    <div className="space-y-6">
      <OrderDetails orderUuid={orderUuid} />
    </div>
  );
}
